import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { gap } from "@ui/styles/utils";
import { NextButton } from "@ui/components/buttons/nextButton";

interface BackButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	path?: string;
	text?: string;
}
export const BackButton: React.FC<BackButtonProps> = ({ path, text, onClick, ...htmlProps }) => {
	const history = useHistory();

	return (
		<Container
			{...htmlProps}
			onClick={onClick ? onClick : () => (path ? history.replace(path) : history.replace(Path.Root))}
		>
			<NextButton inverted />
			<div>{text ?? I18n.t("back")}</div>
		</Container>
	);
};

const Container = styled.div`
	cursor: pointer;
	display: flex;
	align-items: center;
	${gap(14, "row")};
	${({ theme }) => theme.textStyles.text};
`;
